import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { fetchBalanceAndBonuses } from 'components/common/BalanceAndBonuses/fetchBalanceAndBonuses';

import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const fetchReBalance =
    ({ setIsLoading, onClose }: { setIsLoading: (value: boolean) => void; onClose: () => void }): AppThunkAction =>
    (dispatch, getState) => {
        const accountId = getState().user.user?.currentAccount.id;

        if (!accountId) {
            dispatch(addMagritteNotification(MagritteNotificationName.BalanceReBalanceError));
            return Promise.resolve();
        }

        setIsLoading(true);

        return fetcher
            .post(`/api/v1/backoffice/re_balance/account/${accountId}`)
            .then(() => {
                onClose();
                dispatch(addMagritteNotification(MagritteNotificationName.BalanceReBalanceSuccess));
            })
            .catch(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.BalanceReBalanceError));
            })
            .then(() => {
                void dispatch(fetchBalanceAndBonuses());
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
